import Vue from 'vue'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import {
  email,
  max,
  min,
  numeric,
  required,
} from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Las contraseñas no coinciden',
})

extend('numerico', {
  validate: value => {
    return !isNaN(value)
  },
  message: 'El dni no es válido',
})

extend('sinpuntos', {
  validate: value => {
    var strinValue = value.toString()
    return strinValue.indexOf('.') === -1
  },
  message: 'No ingrese puntos',
})

extend('email', email)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('required', required)

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
